var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { InputAdornment, Stack, TextField } from '@mui/material';
import classNames from 'classnames';
import { createReactTooltip } from '../../common/tooltip';
import { getVersionBrowserColoringClass } from '../../versionBrowser/utils';
import AccurityIcon from '../../icon/components/AccurityIcon';
import { formatNumericField } from '../utils';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
export var SingleLineField = function (_a) {
    var name = _a.name, type = _a.type, label = _a.label, errorMessage = _a.errorMessage, tooltip = _a.tooltip, dropTargetClassName = _a.dropTargetClassName, inverted = _a.inverted, disabled = _a.disabled, coloring = _a.coloring, value = _a.value, inputContentRight = _a.inputContentRight, numericFormat = _a.numericFormat, icon = _a.icon, autoComplete = _a.autoComplete, style = _a.style, shouldFocus = _a.shouldFocus, showPasswordVisibilityButton = _a.showPasswordVisibilityButton, onChange = _a.onChange, onFocus = _a.onFocus, iconAction = _a.iconAction, onBlur = _a.onBlur, inherited = _a.inherited;
    var _b = useState(false), isPasswordVisible = _b[0], setIsPasswordVisible = _b[1];
    var _c = createReactTooltip(tooltip, 'singleLineField' + name), tooltipAnchorParams = _c.tooltipAnchorParams, tooltipElement = _c.tooltipElement;
    var displayType = type;
    if (type === 'password' && showPasswordVisibilityButton) {
        displayType = isPasswordVisible ? 'text' : 'password';
        inputContentRight = (React.createElement(AccurityIconButton, { onMouseDown: function () { return setIsPasswordVisible(true); }, onMouseUp: function () { return setIsPasswordVisible(false); }, disableRipple: true, tabIndex: -1, size: "small", iconName: isPasswordVisible ? 'mui:Visibility' : 'mui:VisibilityOff' }));
    }
    var onChangeHandler = function (event) {
        var newValue = event.target.value;
        if (numericFormat) {
            newValue = formatNumericField(value, newValue, numericFormat);
        }
        onChange(newValue);
    };
    var fieldIconElement = null;
    if (icon) {
        // don't render clickable icon if there is no action handler or it is used in version browser (coloring property is populated)
        var isClickable = iconAction && !coloring;
        fieldIconElement = (React.createElement("div", { className: classNames('SingleLineField__icon', dropTargetClassName) },
            React.createElement(AccurityIconButton, { iconName: icon, disabled: !isClickable, onClick: iconAction, color: "dark" })));
    }
    return (React.createElement("div", __assign({ className: classNames('SingleLineField', { 'SingleLineField--inverted': inverted }, dropTargetClassName, getVersionBrowserColoringClass(coloring)) }, tooltipAnchorParams),
        tooltipElement,
        React.createElement(Stack, { position: "absolute", right: "0", direction: "row", sx: { zIndex: 3 } }, inherited && React.createElement(AccurityIcon, { iconName: "mui:LayersOutlined", fontSize: "small", color: "secondary700" })),
        fieldIconElement,
        React.createElement(TextField, { type: displayType, name: name, label: label, error: Boolean(errorMessage), helperText: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.trim(), disabled: disabled, value: value || '', onChange: onChangeHandler, onFocus: onFocus, onBlur: onBlur, fullWidth: true, autoFocus: shouldFocus, autoComplete: autoComplete ? 'on' : 'off', InputProps: {
                endAdornment: inputContentRight ? (React.createElement(InputAdornment, { position: "end" }, inputContentRight)) : null
            }, InputLabelProps: {
                shrink: !!value ? true : undefined,
            }, style: style })));
};
export default SingleLineField;
//# sourceMappingURL=SingleLineField.js.map